import React, { PureComponent, Fragment } from 'react';
import { AmazonOutlined, InfoCircleOutlined, SelectOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {
  Input,
  Button,
  message,
  Checkbox,
  Select,
  Tooltip,
  Row,
  Col,
  Modal,
  Spin,
  Empty,
} from 'antd';
import { connect } from 'dva';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ComposeApplicator } from 'lodash-decorators/applicators';
import styles from '../style.less';
import CreateRole from './CreateRole';
import CreatePolicy from './CreatePolicy';
import { nl2br } from '../../../utils/utils';
import { auditPolicy, fullPolicy } from './PolicyJSON';
import { title } from '@/defaultSettings';
import AwsSvgIcon from '../../../../public/aws-1.svg';
import GLOBAL_META_CONFIG from '@/../config/AllServices';
import organisation from '@/models/organisation';

const FormItem = Form.Item;
const { Option } = Select;
const timeStamp = new Date().getTime();

@connect(({ organisation, cloudAccount }) => ({
  organisationId: organisation.current.id,
  cloudAccountId: cloudAccount.cloudAccountIdRef,
  deployStackButtonLoading: cloudAccount.deployStackButtonLoading,
  deployCftButtonLoading: cloudAccount.deployCftButtonLoading,
  deployStackCheckboxDisabled: cloudAccount.deployStackCheckboxDisabled,
  scanRunningInstances: cloudAccount.scanRunningInstances,
  regionsArray: cloudAccount.regionsArray,
  regionsLoading: cloudAccount.regionsLoading,
}))
class AWSCredentials extends PureComponent {
  state = {
    value: '',
    loading: false,
    visible: false,
    viewPolicy: '',
    roleArn: '',
    viewPolicyModal: false,
    regions: [],
    selectedEagleEyeRegions: ['us-east-1'],
  };
  handleSelectedRegions = async selectedRegions => {
    // Step 1: Update the state
    this.setState({ selectedEagleEyeRegions: selectedRegions });
  };
  componentDidMount() {
    // smooth scroll to top
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    this.props.setFormRef(this);
  }
  componentDidUpdate(prevProps, prevState) {
    const { roleArn, externalId } = this.props.sentRequireData.data;
    const { roleArn: prevRoleArn, externalId: prevExternalId } = prevProps.sentRequireData.data;

    // If roleArn or externalId changes, fetch regions again
    if (roleArn !== prevRoleArn || externalId !== prevExternalId) {
      this.fetchRegions();
    }
  }

  // Method to fetch regions
  fetchRegions = () => {
    const { roleArn } = this.props.sentRequireData.data;
    const externalId = this.props.organisationId;
    if (roleArn && externalId) {
      // Trigger action to fetch dynamic regions
      this.props.dispatch({
        type: 'cloudAccount/getDynamicRegions',
        payload: {
          roleARN: roleArn,
          externalId,
        },
      });
    }
  };
  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'cloudAccount/save',
      payload: {
        deployStackButtonLoading: false,
        deployStackCheckboxDisabled: true,
        deployCftButtonLoading: false,
      },
    });
  }

  onChange = e => {
    this.props.sentRequireData.selectedPolicy(e.target.value);
    this.setState({
      value: e.target.value,
    });
  };

  showModal = val => {
    this.setState({
      visible: true,
      viewPolicy: val,
    });
  };

  onFormValuesChange = (field, value) => {
    this.props.sentRequireData.providerCallback('authMethodData', {
      [field]: value,
    });
  };

  validateForm = () => {
    return this.props.form.validateFields(['roleArn'], (err, values) => {
      if (!err) {
        // this.props.form.resetFields();
      }
    });
  };

  handleOk = () => {
    message.success('Copied');
  };

  onFormValuesChange = (field, value) => {
    this.props.sentRequireData.providerCallback('authMethodData', {
      [field]: value,
    });
  };

  validateForm = () => {
    return this.props.form.validateFields(['roleArn'], (err, values) => {
      if (!err) {
        // this.props.form.resetFields();
      }
    });
  };

  handleCancel = () => {
    this.setState({ visible: false });
  };

  renderTitle = () => {
    const { viewPolicy } = this.state;

    let title = '';
    switch (viewPolicy) {
      case 'Full Protection Policy':
        title = 'Full Protection Policy';
        return title;
      case 'Security Audit Policy':
        title = 'Security And Audit Policy';
        return title;

      default:
        return null;
    }
  };

  formChangeHandler = e => {
    let field = e.target.name;
    let { value, checked } = e.target;

    this.props.sentRequireData.providerCallback('authMethodData', {
      [field]: field === 'deployedCftCheck' ? checked : value.trim(),
    });
  };

  handleRegionChange = value => {
    this.props.sentRequireData.providerCallback('authMethodData', {
      region: value,
    });
  };

  getUrlToRedirect = (externalId, region, type) => {
    if (type !== 'loginToAWS') {
      const { dispatch, organisationId } = this.props;
      const { roleArn } = this.props.sentRequireData.data;
      const { selectedEagleEyeRegions } = this.state;
      dispatch({
        type: 'cloudAccount/generateUrl',
        payload: {
          type,
          externalId,
          region,
          roleArn,
          organisationId,
          actionStatus: 'creating',
          provider: 'aws',
          eagleEyeRegions: selectedEagleEyeRegions,
        },
      });
    } else
      window
        .open('https://console.aws.amazon.com/console/home?nc2=h_ct&src=header-signin', '_blank')
        .focus();
  };

  render() {
    const {
      organisationId,
      cloudAccountId,
      authKey,
      cloudAccountIdRef,
      deployCftButtonLoading,
      deployStackButtonLoading,
      dispatch,
      regionsArray,
      organisation,
      regionsLoading,
    } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 9 },
      wrapperCol: { span: 14 },
    };
    const { protectionLevel, accountName } = this.props.sentRequireData;
    let { deployedCftCheck, region } = this.props.sentRequireData.data;

    const { externalId, roleArn } = this.props.sentRequireData.data;

    // data for the first TWO steps
    const data = [
      {
        title: 'AWS Login',
        description: () => {
          return <p>Log in to your AWS Account.</p>;
        },
        buttonText: 'Login to AWS',
        buttonKey: 'loginToAWS',
      },
      {
        title: 'Create IAM Roles and Policy',
        // description: `Create the required IAM Roles & Policy using the CloudFormation template.<br/>This CFT will create 1 Service account, 1 Administrator role and 1 Execution role.`,
        description: () => {
          return (
            <p>
              Create the required IAM Roles & Policy using the CloudFormation template.
              <Button
                onClick={() => {
                  this.setState(state => {
                    return {
                      ...state,
                      viewPolicyModal: !state.viewPolicyModal,
                    };
                  });
                }}
                type="link"
              >
                View Policy
              </Button>
              <br />
              <br />
              Mark{' '}
              <b>
                &lt;&lt;I acknowledge that AWS CloudFormation might create IAM resources with custom
                names.&gt;&gt;
              </b>{' '}
              and click <b>Create Stack</b>
            </p>
          );
        },
        buttonText: 'Create IAM Roles',
        buttonKey: 'deployCft',
      },
    ];
    // data for second last step
    const step3 = {
      title: 'Create Stack',
      description:
        'In this step, you will be deploying a Stack  with multiple stacksets that deploys required cloud resoucres,to perform advance scanning.',
      buttonText: 'Deploy Stack',
      buttonKey: 'deployStack',
    };
    // data for last step
    const step4 = {
      title: 'Choose Configuration',
      description: `This configuration is recommended to first-time users for a much quicker & cost-efficient process. Unselecting this configuration will make Cloudxray scan all your EC2 instances - running instances as well as stopped instances. You can change this later from this Cloud Account's configurations.`,
    };

    const policy = `{
      "Version": "2012-10-17T00:00:00.000Z",
      "Statement": [
        {
          "Effect": "Allow",
          "Resource": "*",
          "Action": [
            "acm:Describe*",
            "apigateway:*",
            "acm:List*",
            "application-autoscaling:Describe*",
            "appmesh:Describe*",
            "appmesh:List*",
            "appsync:List*",
            "athena:List*",
            "autoscaling:Describe*",
            "batch:DescribeComputeEnvironments",
            "batch:DescribeJobDefinitions",
            "chime:List*",
            "cloud9:Describe*",
            "cloud9:ListEnvironments",
            "clouddirectory:ListDirectories",
            "cloudformation:DescribeStack*",
            "cloudformation:GetTemplate",
            "cloudformation:ListStack*",
            "cloudformation:GetStackPolicy",
            "cloudfront:Get*",
            "cloudfront:List*",
            "cloudhsm:ListHapgs",
            "cloudhsm:ListHsms",
            "cloudhsm:ListLunaClients",
            "cloudsearch:DescribeDomains",
            "cloudsearch:DescribeServiceAccessPolicies",
            "cloudtrail:DescribeTrails",
            "cloudtrail:GetEventSelectors",
            "cloudtrail:GetTrailStatus",
            "cloudtrail:ListTags",
            "cloudtrail:LookupEvents",
            "cloudwatch:Describe*",
            "codebuild:ListProjects",
            "codecommit:BatchGetRepositories",
            "codecommit:GetBranch",
            "codecommit:GetObjectIdentifier",
            "codecommit:GetRepository",
            "codecommit:List*",
            "codedeploy:Batch*",
            "codedeploy:Get*",
            "codedeploy:List*",
            "codepipeline:ListPipelines",
            "codestar:Describe*",
            "codestar:List*",
            "cognito-identity:ListIdentityPools",
            "cognito-idp:ListUserPools",
            "cognito-sync:Describe*",
            "cognito-sync:List*",
            "comprehend:Describe*",
            "comprehend:List*",
            "config:Deliver*",
            "config:Describe*",
            "config:Get*",
            "datapipeline:DescribeObjects",
            "datapipeline:DescribePipelines",
            "datapipeline:EvaluateExpression",
            "datapipeline:GetPipelineDefinition",
            "datapipeline:ListPipelines",
            "datapipeline:QueryObjects",
            "datapipeline:ValidatePipelineDefinition",
            "datasync:Describe*",
            "datasync:List*",
            "dax:Describe*",
            "dax:ListTags",
            "directconnect:Describe*",
            "dms:Describe*",
            "dms:ListTagsForResource",
            "ds:DescribeDirectories",
            "dynamodb:DescribeContinuousBackups",
            "dynamodb:DescribeGlobalTable",
            "dynamodb:DescribeTable",
            "dynamodb:DescribeTimeToLive",
            "dynamodb:ListBackups",
            "dynamodb:ListGlobalTables",
            "dynamodb:ListStreams",
            "dynamodb:ListTables",
            "ec2:Describe*",
            "ecr:DescribeRepositories",
            "ecr:GetRepositoryPolicy",
            "ecs:Describe*",
            "ecs:List*",
            "eks:DescribeCluster",
            "eks:ListClusters",
            "elasticache:Describe*",
            "elasticbeanstalk:Describe*",
            "elasticfilesystem:DescribeFileSystems",
            "elasticloadbalancing:Describe*",
            "elasticmapreduce:Describe*",
            "elasticmapreduce:ListClusters",
            "elasticmapreduce:ListInstances",
            "es:Describe*",
            "es:ListDomainNames",
            "events:DescribeEventBus",
            "events:ListRules",
            "firehose:Describe*",
            "firehose:List*",
            "fsx:Describe*",
            "fsx:List*",
            "gamelift:ListBuilds",
            "gamelift:ListFleets",
            "glacier:DescribeVault",
            "glacier:GetVaultAccessPolicy",
            "glacier:ListVaults",
            "globalaccelerator:Describe*",
            "globalaccelerator:List*",
            "greengrass:List*",
            "guardduty:Get*",
            "guardduty:List*",
            "iam:GenerateCredentialReport",
            "iam:Get*",
            "iam:List*",
            "iam:SimulateCustomPolicy",
            "iam:SimulatePrincipalPolicy",
            "iot:Describe*",
            "iot:List*",
            "kinesis:DescribeStream",
            "kinesis:ListStreams",
            "kinesis:ListTagsForStream",
            "kinesisanalytics:ListApplications",
            "kms:Describe*",
            "kms:Get*",
            "kms:List*",
            "lambda:GetAccountSettings",
            "lambda:GetPolicy",
            "lambda:List*",
            "license-manager:List*",
            "logs:Describe*",
            "logs:ListTagsLogGroup",
            "machinelearning:DescribeMLModels",
            "mediaconnect:Describe*",
            "mediaconnect:List*",
            "mediastore:GetContainerPolicy",
            "mediastore:ListContainers",
            "opsworks-cm:DescribeServers",
            "organizations:List*",
            "organizations:Describe*",
            "quicksight:Describe*",
            "quicksight:List*",
            "ram:List*",
            "rds:Describe*",
            "rds:DownloadDBLogFilePortion",
            "rds:ListTagsForResource",
            "redshift:Describe*",
            "rekognition:Describe*",
            "rekognition:List*",
            "robomaker:Describe*",
            "robomaker:List*",
            "route53:Get*",
            "route53:List*",
            "route53domains:GetDomainDetail",
            "route53domains:GetOperationDetail",
            "route53domains:ListDomains",
            "route53domains:ListOperations",
            "route53domains:ListTagsForDomain",
            "route53resolver:List*",
            "s3:GetAccelerateConfiguration",
            "s3:GetAnalyticsConfiguration",
            "s3:GetBucket*",
            "s3:GetEncryptionConfiguration",
            "s3:GetInventoryConfiguration",
            "s3:GetLifecycleConfiguration",
            "s3:GetMetricsConfiguration",
            "s3:GetObjectAcl",
            "s3:GetObjectVersionAcl",
            "s3:GetReplicationConfiguration",
            "s3:ListAllMyBuckets",
            "sagemaker:Describe*",
            "sagemaker:List*",
            "sdb:DomainMetadata",
            "sdb:ListDomains",
            "securityhub:Get*",
            "securityhub:List*",
            "serverlessrepo:GetApplicationPolicy",
            "serverlessrepo:List*",
            "ses:GetIdentityDkimAttributes",
            "ses:GetIdentityVerificationAttributes",
            "ses:ListIdentities",
            "ses:ListVerifiedEmailAddresses",
            "shield:Describe*",
            "shield:List*",
            "snowball:ListClusters",
            "snowball:ListJobs",
            "sns:GetTopicAttributes",
            "sns:ListSubscriptionsByTopic",
            "sns:ListTopics",
            "sqs:GetQueueAttributes",
            "sqs:ListQueues",
            "ssm:Describe*",
            "ssm:ListDocuments",
            "states:ListStateMachines",
            "storagegateway:DescribeBandwidthRateLimit",
            "storagegateway:DescribeCache",
            "storagegateway:DescribeCachediSCSIVolumes",
            "storagegateway:DescribeGatewayInformation",
            "storagegateway:DescribeMaintenanceStartTime",
            "storagegateway:DescribeNFSFileShares",
            "storagegateway:DescribeSnapshotSchedule",
            "storagegateway:DescribeStorediSCSIVolumes",
            "storagegateway:DescribeTapeArchives",
            "storagegateway:DescribeTapeRecoveryPoints",
            "storagegateway:DescribeTapes",
            "storagegateway:DescribeUploadBuffer",
            "storagegateway:DescribeVTLDevices",
            "storagegateway:DescribeWorkingStorage",
            "storagegateway:List*",
            "tag:GetResources",
            "tag:GetTagKeys",
            "tag:GetTagValues",
            "transfer:Describe*",
            "transfer:List*",
            "translate:List*",
            "trustedadvisor:Describe*",
            "waf:ListWebACLs",
            "waf-regional:ListWebACLs",
            "workspaces:Describe*"
          ]
        },
        {
          "Effect": "Allow",
          "Resource": [
            "arn:aws:apigateway:*::/restapis",
            "arn:aws:apigateway:*::/restapis/*/authorizers",
            "arn:aws:apigateway:*::/restapis/*/authorizers/*",
            "arn:aws:apigateway:*::/restapis/*/resources",
            "arn:aws:apigateway:*::/restapis/*/resources/*",
            "arn:aws:apigateway:*::/restapis/*/resources/*/methods/*",
            "arn:aws:apigateway:*::/vpclinks"
          ],
          "Action": [
            "apigateway:GET"
          ]
        }
      ]
    }`;
    return (
      <>
        <h5
          style={{
            marginBottom: '20px',
            color: 'black',
            display: 'flex',
            alignItems: 'center',
            gap: '0.3rem',
          }}
        >
          Create required roles for Cloud Account: &nbsp;
          <span
            style={{
              border: '1px solid #91d5ff',
              background: '#e6f7ff',
              color: '#1890ff',
              padding: '1px 8px',
              borderRadius: '5px',
            }}
          >
            {accountName}
          </span>
        </h5>
        <div className={styles.cardMain}>
          {data.map((each, index) => {
            return (
              <Row gutter={16}>
                <Col span={16}>
                  <Row>
                    <Col span={2}>
                      <div
                        style={{
                          width: '26px',
                          height: '26px',
                          color: 'lightgrey',
                          borderRadius: '50%',
                          border: '1px solid lightgrey',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          marginRight: '10px',
                        }}
                      >
                        {index + 1}
                      </div>
                    </Col>
                    <Col span={22}>
                      <h6>{each.title}</h6>
                      {each.description()}
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={6}
                  offset={2}
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    style={{ backgroundColor: 'transparent' }}
                    onClick={() => this.getUrlToRedirect(externalId, region, each.buttonKey)}
                    size="large"
                    loading={each.buttonKey === 'deployCft' && deployCftButtonLoading}
                    disabled={each.buttonKey === 'deployCft' && deployCftButtonLoading}
                  >
                    <img src={AwsSvgIcon} alt="Aws logo here" style={{ marginRight: '10px' }} />
                    {each.buttonText}
                    <svg
                      style={{ marginLeft: '10px' }}
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.7583 0.0507812H9.48709C9.30628 0.0507812 9.15984 0.197222 9.15984 0.378027C9.15984 0.558659 9.30628 0.705099 9.48709 0.705099H12.7583C12.9041 0.705617 13.0478 0.73912 13.1787 0.80319L6.63889 7.34341C6.57569 7.40437 6.53977 7.48813 6.53908 7.57603C6.53821 7.66375 6.57275 7.74802 6.63475 7.81002C6.69692 7.87219 6.78119 7.90673 6.86892 7.90587C6.95665 7.90518 7.0404 7.86908 7.10136 7.80605L13.642 1.26627C13.7059 1.39717 13.7396 1.54085 13.7401 1.6866V4.95786C13.7401 5.13849 13.8866 5.28493 14.0672 5.28493C14.2478 5.28493 14.3943 5.13849 14.3943 4.95786V1.6866C14.3937 1.25297 14.2214 0.837128 13.9147 0.53063C13.608 0.223933 13.1923 0.0514089 12.7587 0.0508784L12.7583 0.0507812Z"
                        fill="#565656"
                      />
                      <path
                        d="M14.0664 6.5931C13.8858 6.5931 13.7394 6.73954 13.7394 6.92017V12.8088C13.7394 13.069 13.6359 13.3187 13.4518 13.5026C13.2679 13.6867 13.0182 13.7901 12.758 13.7901H6.5427V9.5375C6.54218 9.10387 6.36966 8.68803 6.06295 8.38153C5.75642 8.07483 5.34058 7.90231 4.90698 7.90178H0.654332V1.68649C0.654332 1.42624 0.757772 1.17654 0.941688 0.992456C1.12578 0.80854 1.37549 0.7051 1.63572 0.7051H7.52431C7.70494 0.7051 7.85138 0.558659 7.85138 0.378027C7.85138 0.197222 7.70494 0.0507812 7.52431 0.0507812H1.63572C1.20209 0.0512993 0.786251 0.223818 0.479752 0.530534C0.173055 0.837058 0.000530504 1.2529 0 1.6865V12.809C0.000518081 13.2426 0.173037 13.6582 0.479752 13.9649C0.786277 14.2716 1.20212 14.444 1.63572 14.4445H12.7582C13.1918 14.444 13.6075 14.2716 13.9141 13.9649C14.2208 13.6582 14.3932 13.2425 14.3937 12.809V6.92036C14.3937 6.83367 14.3593 6.75043 14.298 6.68913C14.2366 6.62765 14.1535 6.59328 14.0666 6.59328L14.0664 6.5931ZM0.653992 12.8084V8.55574H4.90664C5.16688 8.55574 5.41659 8.65901 5.60067 8.8431C5.78459 9.02719 5.88803 9.27672 5.88803 9.53713V13.7898H1.63538C1.37514 13.7898 1.12543 13.6863 0.941348 13.5023C0.757431 13.3183 0.653992 13.0686 0.653992 12.8084V12.8084Z"
                        fill="#565656"
                      />
                    </svg>
                  </Button>
                </Col>
              </Row>
            );
          })}
        </div>
        <h5 style={{ marginBottom: '20px', color: 'black' }}>Connect with Cloudnosys</h5>
        <div className={styles.cardMain}>
          <Row gutter={[24, 24]}>
            <Col
              span={12}
              lg={12}
              md={24}
              style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
            >
              <p>
                From the Output tab, copy the Role ARN created after deploying the above CFT and
                paste it below:
              </p>
              <p style={{ margin: 0 }}>Cloudnosys Role ARN (RoleARN)</p>
              <Input
                onChange={this.formChangeHandler}
                placeholder="xxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
                name="roleArn"
                value={roleArn.trim()}
              />
            </Col>
            <Col span={12} lg={12} md={24}>
              <img
                src="/roleArns_snippet.png"
                alt="roleArn snippet here"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  boxShadow: '0 2px 4px rgb(0 0 0 / 10%), 0 8px 16px rgb(0 0 0 / 10%)',
                }}
              />
            </Col>
          </Row>
        </div>

        {protectionLevel === 'advanced' && (
          <>
            <h5 style={{ marginBottom: '20px', color: 'black' }}>{step3.title}</h5>
            <div className={styles.cardMain}>
              <p>{step3.description}</p>
              {/* CloudXray Dropdown */}
              <Row gutter={24} style={{ marginBottom: '30px' }}>
                <Col span={14}>
                  <div style={{ maxWidth: '100%' }}>
                    <p style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                      Select a region you want CloudXray (Malware/OS Vulnerabilities detection
                      engine) to be deployed:
                    </p>
                    <p style={{ fontSize: '12px', color: '#666', margin: '0' }}>
                      Note: This will cover your entire account for malware and CVEs.
                    </p>
                  </div>
                </Col>
                <Col
                  span={10}
                  lg={10}
                  md={24}
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                  }}
                >
                  <Select
                    disabled={!roleArn}
                    defaultValue={region}
                    style={{
                      width: '140px',
                    }}
                    size="large"
                    onChange={this.handleRegionChange}
                  >
                    {regionsLoading ? (
                      <Option disabled>
                        <Empty
                          description="Fetching regions..."
                          imageStyle={{
                            height: 30,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        />
                      </Option>
                    ) : regionsArray && regionsArray.length > 0 ? (
                      regionsArray.map(region => (
                        <Option key={region} value={region}>
                          {region}
                        </Option>
                      ))
                    ) : (
                      <Option disabled>
                        <Empty
                          description="No regions!"
                          imageStyle={{
                            height: 30,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        />
                      </Option>
                    )}
                  </Select>
                </Col>
              </Row>
              {/* EagleEye Dropdown */}
              <Row
                gutter={24}
                style={{
                  marginBottom: '20px',
                  alignItems: 'center', // Center-aligns content vertically
                }}
              >
                {/* Text Section */}
                <Col span={14}>
                  <div style={{ maxWidth: '100%' }}>
                    <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                      Select region(s) you want EagleEye (Real-time Threat Detection) to cover:
                    </p>
                    <p style={{ fontSize: '12px', color: '#666', margin: '0' }}>
                      Note: Only the selected region(s) will have real-time monitoring working. We
                      suggest you select only critical regions, as there will be extra cost as logs
                      increase.
                    </p>
                  </div>
                </Col>

                {/* Dropdown Section */}
                <Col
                  span={10}
                  lg={10}
                  md={24}
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                  }}
                >
                  <Select
                    disabled={!roleArn}
                    mode="multiple"
                    defaultValue={regionsArray.length ? ['us-east-1'] : []}
                    style={{
                      width: '280px',
                      whiteSpace: 'nowrap',
                    }}
                    size="large"
                    onChange={this.handleSelectedRegions}
                    maxTagCount={3}
                    maxTagPlaceholder={restValues => `+${restValues.length} more`}
                  >
                    {regionsLoading ? (
                      <Option disabled>
                        <Empty description="Fetching regions..." imageStyle={{ height: 50 }} />
                      </Option>
                    ) : regionsArray && regionsArray.length > 0 ? (
                      regionsArray.map(region => (
                        <Option key={region} value={region}>
                          {region}
                        </Option>
                      ))
                    ) : (
                      <Option disabled>
                        <Empty description="No regions available!" imageStyle={{ height: 50 }} />
                      </Option>
                    )}
                  </Select>
                </Col>
              </Row>

              <Row>
                <Col
                  span={24}
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end', // Aligns the button to the right
                    alignItems: 'center', // Vertically aligns the button
                    marginTop: '20px', // Adds spacing above the button
                  }}
                >
                  <Tooltip placement="bottom" title={!roleArn && 'Please paste the RoleARN.'}>
                    <Button
                      style={{ backgroundColor: 'transparent' }}
                      onClick={() => this.getUrlToRedirect(externalId, region, step3.buttonKey)}
                      size="large"
                      loading={deployStackButtonLoading}
                      disabled={!roleArn || deployStackButtonLoading}
                    >
                      <img src={AwsSvgIcon} alt="Aws logo here" style={{ marginRight: '10px' }} />
                      {step3.buttonText}
                      <svg
                        style={{ marginLeft: '10px' }}
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.7583 0.0507812H9.48709C9.30628 0.0507812 9.15984 0.197222 9.15984 0.378027C9.15984 0.558659 9.30628 0.705099 9.48709 0.705099H12.7583C12.9041 0.705617 13.0478 0.73912 13.1787 0.80319L6.63889 7.34341C6.57569 7.40437 6.53977 7.48813 6.53908 7.57603C6.53821 7.66375 6.57275 7.74802 6.63475 7.81002C6.69692 7.87219 6.78119 7.90673 6.86892 7.90587C6.95665 7.90518 7.0404 7.86908 7.10136 7.80605L13.642 1.26627C13.7059 1.39717 13.7396 1.54085 13.7401 1.6866V4.95786C13.7401 5.13849 13.8866 5.28493 14.0672 5.28493C14.2478 5.28493 14.3943 5.13849 14.3943 4.95786V1.6866C14.3937 1.25297 14.2214 0.837128 13.9147 0.53063C13.608 0.223933 13.1923 0.0514089 12.7587 0.0508784L12.7583 0.0507812Z"
                          fill="#565656"
                        />
                        <path
                          d="M14.0664 6.5931C13.8858 6.5931 13.7394 6.73954 13.7394 6.92017V12.8088C13.7394 13.069 13.6359 13.3187 13.4518 13.5026C13.2679 13.6867 13.0182 13.7901 12.758 13.7901H6.5427V9.5375C6.54218 9.10387 6.36966 8.68803 6.06295 8.38153C5.75642 8.07483 5.34058 7.90231 4.90698 7.90178H0.654332V1.68649C0.654332 1.42624 0.757772 1.17654 0.941688 0.992456C1.12578 0.80854 1.37549 0.7051 1.63572 0.7051H7.52431C7.70494 0.7051 7.85138 0.558659 7.85138 0.378027C7.85138 0.197222 7.70494 0.0507812 7.52431 0.0507812H1.63572C1.20209 0.0512993 0.786251 0.223818 0.479752 0.530534C0.173055 0.837058 0.000530504 1.2529 0 1.6865V12.809C0.000518081 13.2426 0.173037 13.6582 0.479752 13.9649C0.786277 14.2716 1.20212 14.444 1.63572 14.4445H12.7582C13.1918 14.444 13.6075 14.2716 13.9141 13.9649C14.2208 13.6582 14.3932 13.2425 14.3937 12.809V6.92036C14.3937 6.83367 14.3593 6.75043 14.298 6.68913C14.2366 6.62765 14.1535 6.59328 14.0666 6.59328L14.0664 6.5931ZM0.653992 12.8084V8.55574H4.90664C5.16688 8.55574 5.41659 8.65901 5.60067 8.8431C5.78459 9.02719 5.88803 9.27672 5.88803 9.53713V13.7898H1.63538C1.37514 13.7898 1.12543 13.6863 0.941348 13.5023C0.757431 13.3183 0.653992 13.0686 0.653992 12.8084V12.8084Z"
                          fill="#565656"
                        />
                      </svg>
                    </Button>
                  </Tooltip>
                </Col>
              </Row>

              <Row
                gutter={24}
                style={{
                  marginBottom: '20px',
                }}
              >
                <Col span={20}>
                  <Tooltip
                    placement="bottom"
                    title={this.props.deployStackCheckboxDisabled && 'Please deploy CFT first'}
                  >
                    <Checkbox
                      disabled={this.props.deployStackCheckboxDisabled}
                      checked={deployedCftCheck}
                      name="deployedCftCheck"
                      onChange={this.formChangeHandler}
                    >
                      I acknowledge that I have deployed the Cloud Formation Template in my account
                      & the creation of resources has been completed.
                    </Checkbox>
                  </Tooltip>
                </Col>
              </Row>
            </div>
            {deployedCftCheck && (
              <>
                <h5 style={{ marginBottom: '20px', color: 'black' }}>{step4.title}</h5>
                <div className={styles.cardMain}>
                  <Row>
                    <Col span={24}>
                      <Row
                        gutter={24}
                        style={{
                          marginBottom: '10px',
                        }}
                      >
                        <Col>
                          <p>{step4.description}</p>
                        </Col>
                      </Row>
                      <Row
                        gutter={24}
                        style={{
                          marginBottom: '20px',
                        }}
                      >
                        <Col span={14}>
                          <Tooltip
                            placement="bottom"
                            title={!deployedCftCheck && 'Please deploy CFT first'}
                          >
                            <Checkbox
                              disabled={!roleArn}
                              checked={this.props.scanRunningInstances}
                              name="scanRunningInstances"
                              onChange={e => {
                                const { dispatch } = this.props;
                                dispatch({
                                  type: 'cloudAccount/save',
                                  payload: { scanRunningInstances: e.target.checked },
                                });
                              }}
                            >
                              Scan running instances only.
                            </Checkbox>
                          </Tooltip>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </>
            )}
          </>
        )}
        <Modal
          visible={this.state.viewPolicyModal}
          title="AWS managed SecurityAudit Policy"
          width="560px"
          onCancel={() => {
            this.setState(state => {
              return {
                ...state,
                viewPolicyModal: !state.viewPolicyModal,
              };
            });
          }}
          bodyStyle={{ height: '300px', overflowY: 'scroll' }}
          footer={[
            <Button
              key="back"
              onClick={() => {
                this.setState(state => {
                  return {
                    ...state,
                    viewPolicyModal: !state.viewPolicyModal,
                  };
                });
              }}
            >
              Close
            </Button>,
          ]}
        >
          <pre style={{ overflow: 'initial' }}>
            <code dangerouslySetInnerHTML={{ __html: nl2br(policy) }} />
          </pre>
        </Modal>
      </>
    );
  }
}
const WrappedApp = Form.create()(AWSCredentials);

export default WrappedApp;
